import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import filters from "./filters";
import i18n from "./i18n";
import VueCookie from "vue-cookie";
import VueResource from "vue-resource";
import VueCarousel from "@chenfengyuan/vue-carousel";
import Embed from "v-video-embed";
import { initValidation } from "@/common/utils/validation/validationRules";
import { ValidationObserver, ValidationProvider } from "vee-validate";

// Register components globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

import 'leaflet/dist/leaflet.css';
import "@/scss/brand1.scss";

//Brand style
/*const branding = {
  brand1CSS: () => import("@/scss/brand1.scss"),
  brand2CSS: () => import("@/scss/brand2.scss"),
  brand3CSS: () => import("@/scss/brand3.scss")
};*/

let brandParam = "brand1"; // Values: 'brand1', 'brand2', 'brand3'
//Vue.config.multiBranding = branding;

if (process.env.NODE_ENV === "production") {
  Vue.config.productionTip = false;
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
} else if (process.env.NODE_ENV === "development") {
  // Local vue config
  Vue.config.productionTip = false;
  Vue.config.devtools = true;
  Vue.config.performance = true;
  //This is a switch to the branding
  Vue.config.brandParam = brandParam; //
  //set jwt token for use in authorized api requests
  /*const frJwt =
    "eyJ0eXAiOiJKV1QiLCJraWQiOiJPYUlROVo4emw1WWFOanFZMVFmZlhYd1Jhb3M9IiwiYWxnIjoiUlMyNTYifQ.eyJhdF9oYXNoIjoiT1ljdUNheTNjaG5uZnpGUTJybmFNUSIsInN1YiI6InN1cHBsaWVyX3Rlc3R1c2VyMSIsImZpcnN0bmFtZSI6IlNhdHllbmRyYSIsImF1ZGl0VHJhY2tpbmdJZCI6IjZiNTNmMzhlLTdjY2ItNDg1NC04ZDc3LTJkNjIyYjExYTZlMy0xNzg3MDg4Iiwicm9sZXMiOlsiQmFzaWNTdXBwbGllciJdLCJpc3MiOiJodHRwczovL2lhbS1jZHQubWFlcnNrLmNvbS9hY20vb2F1dGgyL21hdSIsInRva2VuTmFtZSI6ImlkX3Rva2VuIiwibm9uY2UiOiJ6eHpIZGtKMkQ0N2loOTVUOUlGViIsImxhc3RuYW1lIjoiSmFpbiIsImF1ZCI6ImJjYTAwMSIsImFjciI6IjAiLCJlbnRpdHlfdHlwZSI6InN1cHBsaWVyIiwiZW50aXR5X2NvZGUiOiJzdXBwbGllcl8xMDU4MDQ0IiwiYXpwIjoiYmNhMDAxIiwiYXV0aF90aW1lIjoxNjAwNjc2OTcwLCJyZWFsbSI6Ii9tYXUiLCJleHAiOjE2MDA2ODQxNzAsInRva2VuVHlwZSI6IkpXVFRva2VuIiwiaWF0IjoxNjAwNjc2OTcwLCJlbWFpbCI6InNhdHllbmRyYS5qYWluQG1hZXJzay5jb20iLCJ1c2VybmFtZSI6InN1cHBsaWVyX3Rlc3R1c2VyMSJ9.ICFDM8jGG4v8hu-3dvHolo6zcXL_e7cPDpT2YvE-p1bY_lrSadCxtKsQqOka46T4-Ayx6dKQekwY0f0J7RwYvpiDe4sBqDJRVoRp2NymNCzWNf3m_7ElaG34Gk4yddOjVQDkvD3XdQ8ipUT2GDvJuJs1L7XHJYNV-RG55dH8WUaOXWXGuhEjnlVwXXEn1bQP6wOginTts0UHpuGtJFgl057IHkA-LNN-PRnfjhQd62v1EXPGqzMn2-wXtw8LGnSrZKf2T__mYMo5A92gl7-8aJDcUCr0o6cnbKlnCgnyrCFQvN4bEZp4lzMRwmzFGQMOeJ8dg1ijibV67NJgFenpXQ";
  window.localStorage.setItem("frJwt", frJwt);*/
}

Vue.use(VueCookie);
Vue.use(VueResource);
Vue.use(VueCarousel);
Vue.use(Embed);

initValidation();

new Vue({
  router,
  store,
  i18n,
  filters,
  render: h => h(App)
}).$mount("#app");
